import React, { useEffect, useState } from 'react';

import receiptline from 'receiptline';

import qz from 'qz-tray';

export function Test(): JSX.Element {
  const [printers, setPrinters] = useState([] as string[]);
  const [printer, setPrinter] = useState('');

  useEffect(() => {
    qz.websocket.connect().then(function () {
      alert('Connected!');
    });
  }, []);

  function print() {
    const doc = `"PIZZARIA BOM SABOR
        ┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈
        04/04/2023 22:00
        ┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈
        "MESA 02
        ┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈
        "CUPOM NÃO FISCAL
        ┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈
        |"CERVEJA BALDE BUDWEISER LONG NECK
        |R$ 38,99 |1x| R$ 38,99
        
        |"AGUA COM GÁS
        |R$ 3,00 |2x| R$ 6,00
        ┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈
        |"TOTAIS
        |SUB-TOTAL | R$ 44,99
        |TOTAL | R$ 44,99
        ┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈
        |"PAGAMENTO
        |CRÉDITO | R$ 44,99
        ┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈
        |"ENTREGA
        |CONSUMO NO LOVAL
        ┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈
        "CÓDIGO DO PEDIDO: 123456
        TECNOLOGIA
        WWW.TEM-PEDIDO.WEB.APP
        
        
        
        =
        
        
        |"CLIENTE: SILVANIA
        ┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈
        |CONSUMO NO LOCAL
        ┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈
        |"ITENS DO PEDIDO
        |1x CERVEJA BALDE BUDWEISER LONG NECK
        |2x AGUA COM GÁS
        
        
        =`;

    // printer example
    const _printer = {
      cpl: 48,
      encoding: 'cp860',
      upsideDown: false,
      gamma: 1.8,
      command: 'escpos',
      spacing: true,
    } as receiptline.Printer;

    const command = receiptline.transform(doc, _printer);

    const config = qz.configs.create(printer);

    qz.print(config, [command]).then(() => {
      alert('Sent data to printer');
    });
  }

  function findPrinters() {
    qz.printers
      .find()
      .then(data => {
        setPrinters(data as string[]);
      })
      .catch(function (e) {
        console.error(e);
      });
  }

  return (
    <>
      <p>
        <br />
        <b>Atenção!</b>
        <br />
        Siga os passos a seguir para testar a impressão:
        <br />
        1. clique em buscar impressoras
        <br />
        2. selecione a impressora no select ao lado
        <br />
        3. clique em imprimir
      </p>
      <br />

      <select
        onChange={e => setPrinter(e.target.value)}
        style={{ marginRight: 8 }}
      >
        <option value="">selecione...</option>
        {printers.map(item => (
          <option value={item}>{item}</option>
        ))}
      </select>

      <button type="button" onClick={findPrinters}>
        buscar impressoras
      </button>

      <br />
      <br />
      <br />

      <button type="button" onClick={print}>
        imprimir
      </button>
    </>
  );
}
